import React, { useEffect, useState } from "react";

const CONTRACTOR_ROLES = ["SCHEDULER_DISPATCHER", "SUPERVISOR", "CONTRACTOR"];

const normalizeRole = (r) =>
  String(r || "").trim().toUpperCase().replace(/[/\s-]+/g, "_");

const normalizePayType = (p) =>
  String(p || "").toLowerCase().replace(/[_\s-]+/g, "-");

const formatContact = (c) => {
  if (!c) return "N/A";
  const s = String(c);
  return s.length > 10 ? `+${s.slice(0, -10)}-${s.slice(-10)}` : s;
};

const formatBank = (bsb, acc, name) => {
  if (bsb && acc) return `${bsb} / ${acc}`;
  if (name) return name;
  return "N/A";
};

const formatRate = (rate, payType) => {
  const n = normalizePayType(payType);
  if (n === "pay-per-project" || n === "project") return rate ? `$${rate}/project` : "Project";
  return rate ? `$${rate}/hr` : "Hourly";
};

const ContractorsTab = ({
  sharedUsers = [],
  sharedLoading = false,
  sharedError = "",
  onGoToAddContractor = () => {},
}) => {
  const [contractors, setContractors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (sharedLoading) {
      setLoading(true);
      return;
    }
    const filtered = (sharedUsers || [])
      .filter((u) => u.roles?.some((r) => CONTRACTOR_ROLES.includes(normalizeRole(r))))
      .map((u) => ({
        id: u.id,
        fullName: `${u.firstName} ${u.lastName}`.trim(),
        businessName: u.businessName,
        email: u.email,
        contact: u.contact,
        abnNumber: u.abnNumber,
        bsb: u.bsb,
        accountNumber: u.accountNumber,
        accountName: u.accountName,
        perHourRate: u.perHourRate,
        payType: u.payType,
        gstType: u.gstType,
      }));
    setContractors(filtered);
    setError(sharedError || "");
    setLoading(false);
  }, [sharedUsers, sharedLoading, sharedError]);

  return (
    <>
      <div className="contractor-payroll-toolbar">
        <div className="toolbar-title">
          <h2>Contractors</h2>
          <p>Manage contractor profiles and payment details</p>
        </div>
        <button className="add-contractor-btn" type="button" onClick={onGoToAddContractor}>
          + Add Contractor
        </button>
      </div>

      {loading && <div className="contractor-payroll-state">Loading contractors...</div>}
      {!loading && error && <div className="contractor-payroll-state error">{error}</div>}

      {!loading && !error && (
        <div className="contractor-card-grid">
          {contractors.length === 0
            ? <div className="contractor-payroll-state">No contractors found.</div>
            : contractors.map((c) => (
              <div key={c.id} className="contractor-card">
                <div className="contractor-card-header">
                  <div className="avatar">{(c.fullName || "C").slice(0, 1).toUpperCase()}</div>
                  <div>
                    <div className="contractor-name">{c.fullName || "Unnamed"}</div>
                    <div className="contractor-email">{c.email || "—"}</div>
                  </div>
                  <span className={`rate-pill ${normalizePayType(c.payType) === "pay-per-project" ? "project" : ""}`}>
                    {normalizePayType(c.payType) === "pay-per-project" ? "Project" : "Hourly"}
                  </span>
                </div>
                <div className="contractor-card-body">
                  <div className="info-row"><span>Phone:</span><span>{formatContact(c.contact)}</span></div>
                  <div className="info-row"><span>ABN:</span><span>{c.abnNumber || "N/A"}</span></div>
                  <div className="info-row"><span>Bank:</span><span>{formatBank(c.bsb, c.accountNumber, c.accountName)}</span></div>
                  <div className="info-row"><span>Rate:</span><span className="rate-value">{formatRate(c.perHourRate, c.payType)}</span></div>
                  {c.contractorPayDate && (
                    <div className="info-row"><span>Pay Date:</span><span>{new Date(c.contractorPayDate).toLocaleDateString("en-AU")}</span></div>
                  )}
                </div>
              </div>
            ))
          }
        </div>
      )}
    </>
  );
};

export default ContractorsTab;
